import { render, staticRenderFns } from "./Incidents.vue?vue&type=template&id=880c8e84&scoped=true&"
import script from "./Incidents.vue?vue&type=script&lang=js&"
export * from "./Incidents.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/incident.css?vue&type=style&index=0&id=880c8e84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "880c8e84",
  null
  
)

export default component.exports